import { render, staticRenderFns } from "./LikeAndBookmark.vue?vue&type=template&id=4cd8c3da&"
import script from "./LikeAndBookmark.vue?vue&type=script&lang=js&"
export * from "./LikeAndBookmark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports